import {
  getWebInstrumentations,
  initializeFaro,
  LogLevel,
  type Faro,
} from '@grafana/faro-web-sdk';
import type { ConfigFacade } from '../config/config.facade';
import { useGlobalDependencyProvider } from '../di/useGlobalDependencyProvider';
import type { ObservabilityFacade } from './observability.facade';

export class FaroObservabilityService implements ObservabilityFacade {
  private config: ConfigFacade;
  private faro?: Faro;

  constructor() {
    const di = useGlobalDependencyProvider();
    this.config = di.inject('config');
    const url = this.config.observabilityUrl();
    const environment = this.config.observabilityEnvironment();
    const isActive = this.config.isObservabilityActive();
    const apiKey = this.config.observabilityApiKey();

    if (!isActive) {
      console.info('Observability not active in this environment');
      return;
    }

    this.faro = initializeFaro({
      url,
      apiKey,
      instrumentations: getWebInstrumentations({
        captureConsole: true,
        enablePerformanceInstrumentation: true,
      }),
      consoleInstrumentation: {
        consoleErrorAsLog: true,
        disabledLevels: this.configureConsoleCaptureDisabledLevels(),
      },
      app: {
        name: 'frontend',
        version: '1.0.0',
        environment,
      },
    });
  }
  setUser(id: string) {
    this.faro?.api.setUser({ id });
  }

  private configureConsoleCaptureDisabledLevels(): LogLevel[] {
    const observabilityProfile = this.config.observabilityProfile();

    const prodDisabledConsoleLevels = [
      LogLevel.TRACE,
      LogLevel.DEBUG,
      LogLevel.INFO,
      LogLevel.LOG,
      LogLevel.WARN,
    ];
    const disabledConsoleLevelMap = new Map<string, LogLevel[]>([
      ['dev', []],
      ['prod', prodDisabledConsoleLevels],
    ]);

    let captureConsoleDisabledLevels =
      disabledConsoleLevelMap.get(observabilityProfile);
    if (!captureConsoleDisabledLevels) {
      console.warn(
        `invalid observability profile, given: "${observabilityProfile}", falling back to prod profile `,
      );
      captureConsoleDisabledLevels = prodDisabledConsoleLevels;
    }
    return captureConsoleDisabledLevels;
  }
}
